export enum DocumentUploadRequestObjectType {

  Chase = 1,
  Pend = 2,
  Intake = 3,
  Invoice = 4,
}
